<script setup lang="ts">
import CheckboxGroupFilter from '@pages/search/components/filters/CheckableTagGroup.vue';

interface AccessibilityProps {
  selected?: string[];
}

const { selected = [] } = defineProps<AccessibilityProps>();

const emit = defineEmits<{(e: 'update:selected', value: string[]): void}>();

const accessibility = [
  'pets_allowed',
  'erp',
  'full_time_access',
  'ground_floor',
  'elevator',
  'pmr',
];
</script>

<template>
  <CheckboxGroupFilter
    :options="accessibility"
    :selected="selected"
    translation-prefix="search.filters.other_filters.accessibility"
    @update:selected="emit('update:selected', $event)"
  />
</template>
